import { useState, useEffect } from 'react'
import { createClient } from '@supabase/supabase-js'
import { AnalyticsEvent } from '../../shared/analytics/AnalyticsEvent';
import { useNavigate } from 'react-router-dom';
import CoorayFooter from '../../shared/components/footer/CoorayFooter';
import { sendPageView } from '../../shared/utils/AnalyticsUtils';

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function ResetPasswordPage( { analytics } ) {

  const [session, setSession] = useState(null)
  const [isResettingPassword, setIsResettingPassword] = useState(false)
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [toastMessage, setToastMessage] = useState(null)

  useEffect(() => {
    if (toastMessage) {
        setTimeout(() => {
            setToastMessage(null)
        }, 3000)
    }
}, [toastMessage])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) {
        navigate("/dashboard", {replace: true})
      }
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) {
        navigate("/dashboard", {replace: true})
      }
    })

    sendPageView(analytics, AnalyticsEvent.LOGIN_VIEW, {})

    return () => {
      subscription.unsubscribe()
      // clearTimeout(currentTimeout)
    }
  }, [])

  async function resetPassword() {
    setIsResettingPassword(true)
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'http://example.com/account/update-password',
    })
    console.log(`sign in error ${error}`)
    if (error) {
      setToastMessage("❌ " + error.message)
      setIsResettingPassword(false)
      return
    } else {
      setToastMessage("✅ Password reset email sent. Please check your email for the reset link.")
      setIsResettingPassword(false)
    }
  }


  function onEmailInputChange(event) {
      setEmail(event.target.value)
  }

  if (!session) {
    return (
      <div className='h-full flex flex-col'>
        <div className="navbar bg-base-200 px-4 shrink-0">
            <div className="flex-1">
                <img className="h-12" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/zipmap-resources/full-logo-lightning-light.png"/>
                <div className="text-xl font-bold px-2"></div>
            </div>
        </div>
        <div className="hero bg-base-200 overflow-x-hidden flex-1">
          <div className="hero-content max-w-5xl text-left grid grid-cols-1 gap-4 h-full">
            <div className='flex flex-col items-center w-[400px] max-w-[100%]'>
              <p className="text-lg text-center md:text-left pb-4">Enter your email to reset password</p>
              
              <div className="font-bold text-base pt-2 pb-2 flex items-center w-full">
                  <span>Email</span>
              </div>
              <div className="flex w-full gap-2">
                  <div className="form-control flex-1 relative flex flex-row items-center gap-2">
                      <input className={`input input-bordered flex-1 rounded-md z-1`} value={email} placeholder={"Enter email here ..."} type="email" onChange={onEmailInputChange} />
                  </div>
              </div>

              {
                isResettingPassword &&
                  <div className='w-full flex flex-row items-center justify-center gap-2 py-4'>
                    <div className="loading loading-infinity loading-md"></div>
                    <div className='font-normal text-base-content'>Resetting password ...</div>
                  </div>
              }

              <div className='pt-4 w-full'>
                <button className="btn h-auto btn-primary normal-case w-full" onClick={() => {
                            resetPassword()
                      } }>
                        <div className='flex items-center gap-x-2 justify-between w-full'>
                        <svg className='w-6 h-6' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className='fill-primary-content' d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H13.44L11.37 9.18C11.22 9.03 11.15 8.84 11.15 8.65C11.15 8.46 11.22 8.27 11.37 8.12C11.66 7.83 12.14 7.83 12.43 8.12L15.78 11.47C16.07 11.76 16.07 12.24 15.78 12.53L12.43 15.88C12.14 16.17 11.66 16.17 11.37 15.88C11.08 15.59 11.08 15.11 11.37 14.82L13.44 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z" />
                        <path className="fill-primary-content" d="M2.75 11.25C2.34 11.25 2 11.59 2 12C2 12.41 2.34 12.75 2.75 12.75H9V11.25H2.75Z"/>
                        </svg>
                          <span className='grow text-primary-content'>Reset Password</span>
                        </div>
                        
                  </button>
              </div>
            </div>
          </div>
        </div>
        <CoorayFooter background='bg-base-200 shrink-0' />
        {
                toastMessage && <div className="toast z-10">
                  <div className="alert alert-info">
                  <span className="text-sm">{toastMessage}</span>
                  </div>
              </div>
        }
      </div>
    )
  } else {
    return <div>Redirecting ...</div>
  }
}